// Genvas team management (admin cross-team read-only view)
// admin-dashboard cross-team view; key namespace: team.admin.*
export default {
  // ===== List page =====
  'team.admin.list.title': 'Team Management',
  'team.admin.list.description':
    'Platform-admin view: monitor team metadata, member count, memberships across all teams.',
  'team.admin.list.searchPlaceholder': 'Search by name or ID',
  'team.admin.list.refresh': 'Refresh',
  'team.admin.list.query': 'Search',
  'team.admin.list.tableTotal': '{total} teams',
  'team.admin.list.empty': 'No teams',

  'team.admin.list.column.name': 'Team',
  'team.admin.list.column.owner': 'Owner',
  'team.admin.list.column.memberCount': 'Members',
  'team.admin.list.column.membership': 'Membership',
  'team.admin.list.column.createdAt': 'Created',
  'team.admin.list.column.updatedAt': 'Last Activity',
  'team.admin.list.column.action': 'Actions',
  'team.admin.list.action.detail': 'Details',
  'team.admin.list.copyId': 'Copy Team ID',
  'team.admin.list.copyOwnerId': 'Copy owner uid',
  'team.admin.list.copySuccess': 'Copied',
  'team.admin.list.membership.empty': 'None',
  'team.admin.list.membership.todoBackend':
    'Membership batch summary pending backend (Phase 5+)',

  // ===== Detail Modal =====
  'team.admin.detail.title': 'Team Detail',
  'team.admin.detail.tab.basic': 'Basic',
  'team.admin.detail.tab.members': 'Members',
  'team.admin.detail.tab.membership': 'Membership',
  'team.admin.detail.refresh': 'Refresh',
  'team.admin.detail.loadFailed': 'Failed to load team detail',

  // Basic
  'team.admin.detail.basic.name': 'Name',
  'team.admin.detail.basic.slug': 'Slug',
  'team.admin.detail.basic.slugEmpty': 'Not set',
  'team.admin.detail.basic.teamId': 'Team ID',
  'team.admin.detail.basic.owner': 'Owner',
  'team.admin.detail.basic.memberCount': 'Members',
  'team.admin.detail.basic.createdAt': 'Created at',
  'team.admin.detail.basic.updatedAt': 'Last activity',

  // Members
  'team.admin.members.title': 'Member List',
  'team.admin.members.loadFailed': 'Failed to load members',
  'team.admin.members.column.userId': 'User ID',
  'team.admin.members.column.role': 'Role',
  'team.admin.members.column.joinedAt': 'Joined',
  'team.admin.members.role.owner': 'Owner',
  'team.admin.members.role.admin': 'Admin',
  'team.admin.members.role.member': 'Member',
  'team.admin.members.role.viewer': 'Viewer',

  // Membership
  'team.admin.membership.title': 'Team Memberships',
  'team.admin.membership.todoBackend':
    'Team-membership listing endpoint not yet implemented (Phase 5 will wire team_memberships collection). Grant endpoint accepts but is a Phase 1 stub — not persisted until Phase 5.',
  'team.admin.membership.grantButton': 'Grant Membership',
  'team.admin.membership.grant.title': 'Grant Team Membership',
  'team.admin.membership.grant.warning':
    'Phase 1 stub: endpoint returns 200 but does not persist. Phase 5 will write team_memberships.',
  'team.admin.membership.grant.planLabel': 'Plan',
  'team.admin.membership.grant.planPlaceholder': 'Select a plan',
  'team.admin.membership.grant.durationLabel':
    'Duration override (days, blank = default)',
  'team.admin.membership.grant.creditsLabel':
    'Credits override (blank = default)',
  'team.admin.membership.grant.noteLabel': 'Note (optional)',
  'team.admin.membership.grant.successPersisted': 'Team membership granted',
  'team.admin.membership.grant.successStub':
    'Accepted (Phase 1 stub: not persisted, Phase 5 will persist)',
  'team.admin.membership.grant.failed': 'Grant failed',
};
